// extracted by mini-css-extract-plugin
module.exports = {"root":"thUcB","left":"_1Jn2c","image":"dgHRF","right":"_1sVb3","title":"_2_irx","caption":"XTXgv","action":"_1iC9z","buttonApollo":"_3zRwp","buttonUpgrad":"_1yWOU"};